(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('createUpdateCampaignTemplateController', createUpdateCampaignTemplateController);

  /** @ngInject */
  function createUpdateCampaignTemplateController($scope, $state, $stateParams, campaignTemplateActions, CreateUpdateCampaignTemplateViewModel) {
    var vm = this;
    vm.isEditMode = false;

    vm.saveChanges = function () {
      vm.isEditMode
        ? campaignTemplateActions.updateCampaignTemplate(vm.template.getDtoForPersistence()).then(onSaveUpdateSuccess)
        : campaignTemplateActions.createCampaignTemplate(vm.template.getDtoForPersistence()).then(onSaveUpdateSuccess);
    };

    vm.cancelChanges = function () {
      $state.go('app.loyalty');
    };

    init();

    function init() {
      if ($stateParams.id) {
        vm.isEditMode = true;
        vm.id = $stateParams.id;
      }
      vm.template = new CreateUpdateCampaignTemplateViewModel(vm.id);
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      vm.template.destroy();
    }

    function onSaveUpdateSuccess () {
      $state.go('app.loyalty');
    }

  }
})();
